import React, { useState, useEffect } from 'react';
import './ManageUsers.css'
import AuthService from './auth/AuthServices';

const ManageUsers = () => {
  const [newUserFirstName, setNewUserFirstName] = useState('')
  const [newUserLastName, setNewUserLastName] = useState('')
  const [newUserEmail, setNewUserEmail] = useState('')
  const [newUserRoleUUID, setNewUserRoleUUID] = useState('')
  const [newUserCompany, setNewUserCompany] = useState('')
  const [isAddUserOpen, setIsAddUserOpen] = useState(false)
  const [roles, setRoles] = useState({})
  const [newUserPassword, setNewUserPassword] = useState('')
  const [allUserData, setAllUserData] = useState('')
  const [allUserDataCurrentPage, setAllUserDataCurrentPage] = useState(1)
  const [allUserDataTotalPages, setAllUserDataTotalPages] = useState(1)
  const [handleDeletePopup, setHandleDeletePopup] = useState(false)
  const [editUserUUID, setEditUserUUID] = useState('')
  const [deleteReponse,setDeleteReponse] = useState('')
  const [handleUpdatePopup, setHandleUpdatePopup] = useState(false)
  const [updateUserResponse, setUpdateUserResponse] = useState('')
  const [updateUserSuccess, setUpdateUserSuccess] = useState(false)
  const [deleteUserSuccess, setDeleteUserSuccess] = useState(false)
  const [createNewUserSuccess, setCreateNewUserSuccess] = useState(false)

  useEffect(() => {
    const checkDefaultData = async () => {
      try {
        const Response = AuthService.get_default_data()
          .then(async (res) => {
            if (res.status === 200 || res.status === 201) {
              let data = await res.json()
              setRoles(data.roles)
            } else {
              console.log(res)
            }
            
          })
        } catch (error) {
            console.error('An error occurred:', error);
      };
    };  
    checkDefaultData();
  }, []);

  useEffect(() => {
    const getAllUsers = async () => {
      try {
        const Response = AuthService.get_all_users({
          page: allUserDataCurrentPage,
          per_page: 10
        })
          .then(async (res) => {
            if (res.status === 200 || res.status === 201) {
              let data = await res.json()
              setAllUserData(data.data)
              setAllUserDataCurrentPage(data.current_page)
              setAllUserDataTotalPages(data.pages)
            } else {
              console.log(res)
            }
            
          })
        } catch (error) {
            console.error('An error occurred:', error);
      };
    };  
    getAllUsers();
  }, [allUserDataCurrentPage, ]);

  const selectedUserTableKeys = ["Benutzername","E-Mail", "Roll", "Hinzugefügte Datum"]
 
  const handleAddNewUserClick = () => {
    setIsAddUserOpen(true)
  }

  const handleCloseClick = () => {
    setHandleUpdatePopup(false)
    setHandleDeletePopup(false)
    setNewUserEmail('')
    setNewUserFirstName('')
    setNewUserLastName('')
    setNewUserPassword('')
    setNewUserRoleUUID('')
    setIsAddUserOpen(false);
    setCreateNewUserSuccess(false);
    window.location.reload();
  };

  const handleUserRole = (input_role_code) => {
    const role = roles.find((role)=>role.code === input_role_code)
    const roleUUID = role ? role.uuid : null
    setNewUserRoleUUID(roleUUID)
  };

  const handleAddUserSubmit = async (e) => {
    e.preventDefault();

    const payload = {
      email: newUserEmail,
      firstname: newUserFirstName,
      lastname: newUserLastName,
      role_uuid: newUserRoleUUID,
      companyname: newUserCompany,
      status: "ACTIVED"
    }
    console.log(payload)
    try {
      const Response = AuthService.add_new_user(payload)
        .then(async (res) => {
          if (res.status === 200 || res.status === 201) {
            let data = await res.json();
            setNewUserPassword(data.password)
            setCreateNewUserSuccess(true)
          } else {
            console.error("Error in response:", res.status, res.statusText);
            alert("Failed to create the user. Please try again.");
          }
          
        })
      } catch (error) {
          console.error('An error occurred:', error);
    };
  };

  const handleDelete = (uuid) => {
    setDeleteUserSuccess(false)
    setEditUserUUID(uuid)
    setHandleDeletePopup(true)
  };

  const handleUserDeleteSubmit = async (e) => {
    e.preventDefault();
    const Response = AuthService.delete_user({
      user_uuid: editUserUUID
    })
      .then(async(res) => {
        if (res.status === 200 || res.status === 201) {
          setEditUserUUID('')
          setDeleteReponse('Benutzer gelöscht')
          setDeleteUserSuccess(true)
        } else {
          console.error("Error in response:", res.status, res.statusText);
          alert("Failed to create the user. Please try again.");
        }
      })
  }

  const handleUserUpdateSubmit = async (e) => {
    e.preventDefault();
    const payload = {
      firstname: newUserFirstName,
      lastname: newUserLastName,
      role_uuid: newUserRoleUUID,
      user_uuid: editUserUUID,
      status: "ACTIVED"
    }
    try {
      const Response = AuthService.update_user(payload)
        .then(async (res) => {
          if (res.status === 200 || res.status === 201) {
            let data = await res.json();
            console.log(data)
            setUpdateUserResponse(`${data.role.name} ist für ${data.email} aktualsiert`)
            setUpdateUserSuccess(true)
          } else {
            alert("Failed to create the user. Please try again.");
          }
        })
      } catch (error) {
          console.error('An error occurred:', error);
    };
  }

  // Handler for updating a user (stub for now)
  const handleUpdate = (uuid) => {
    setUpdateUserSuccess(false)
    setEditUserUUID(uuid)
    setHandleUpdatePopup(true)
  };

  return (
    <div className='container'>
    <div className="main-container">
      <header className="header"> 
        <h1 className='title'></h1>
        <button className='add-button' onClick={handleAddNewUserClick}> + Neue Benutzer </button>
      </header>
      {isAddUserOpen && (
        <div className="popup">
        <div className="popup-content">
          <span className="close" onClick={handleCloseClick}>&times;</span>
          {createNewUserSuccess && newUserPassword && (
            <div className="popup-message">
              Bitte notieren Sie das Passwort für {newUserEmail}: {newUserPassword}
            </div>
          )}
          {!createNewUserSuccess && (
            <div>
              <h2 className="popup-title">Bitte Ausfüllen</h2>
              <form onSubmit={handleAddUserSubmit} className="popup-form">
                <label htmlFor="first-name" className="popup-label">
                  Vorname:
                  <input
                    id="first-name"
                    type="text"
                    className="popup-input"
                    value={newUserFirstName}
                    onChange={(e) => setNewUserFirstName(e.target.value)}
                    placeholder="Geben Sie den Vornamen ein"
                  />
                </label>
      
                <label htmlFor="last-name" className="popup-label">
                  Nachname:
                  <input
                    id="last-name"
                    type="text"
                    className="popup-input"
                    value={newUserLastName}
                    onChange={(e) => setNewUserLastName(e.target.value)}
                    placeholder="Geben Sie den Nachnamen ein"
                  />
                </label>
      
                <label htmlFor="email" className="popup-label">
                  E-mail:
                  <input
                    id="email"
                    type="email"
                    className="popup-input"
                    value={newUserEmail}
                    onChange={(e) => setNewUserEmail(e.target.value)}
                    placeholder="Geben Sie die E-Mail-Adresse ein"
                  />
                </label>
      
                <label htmlFor="company" className="popup-label">
                  Firma/Kanzlei Name:
                  <input
                    id="company"
                    type="text"
                    className="popup-input"
                    value={newUserCompany}
                    onChange={(e) => setNewUserCompany(e.target.value)}
                    placeholder="Geben Sie den Firmennamen ein"
                  />
                </label>
      
                <label htmlFor="role-select" className="popup-label">
                  Rolle:
                  <select
                    id="role-select"
                    className="popup-select"
                    onChange={(e) => handleUserRole(e.target.value)}
                  >
                    <option value="">
                      Rolle auswählen
                    </option>
                    <option value="administrator">SuperUser</option>
                    <option value="kanzlei">SteuerberaterKanzlei</option>
                    <option value="firma">Firma</option>
                  </select>
                </label>
      
                <button type="submit" className="popup-submit-button">
                  Benutzer hinzufügen
                </button>
              </form>
            </div>
          )}
        </div>
        </div>
      )}
    {allUserData && (
    <div>
      <h2 className='results-title'>Alle Benutzer</h2>    
      <div className='all-results-table'>
        <table className='table'>
          <thead>
            <tr>
              {selectedUserTableKeys.map((key) => (
                <th key={key}>{key}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {allUserData.map((row, index) => (
              <tr key={index}>
                <td>{row.firstname} { } {row.lastname}</td>
                <td>{row.email}</td>
                <td>{row.role.name}</td>
                <td>{row.date_added}</td>
                <td>
                  <button onClick={() => handleUpdate(row.uuid)}>Update</button>
                  <button onClick={() => handleDelete(row.uuid)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    )}
    {handleDeletePopup && (
        <div className='popup'>
          <div className='popup-content'>
          <span className="close" onClick={handleCloseClick}>
            &times;
            </span>
            <div>{deleteReponse}</div>
            {!deleteUserSuccess && (
              <div className={'popup-input-container'}>
                <div>Sind Sie sicher, dass Sie diesen Benutzer löschen möchten?</div>
                <input className={'popup-submit-button'} type="button" onClick={handleUserDeleteSubmit} value={'Löschen'} />
              </div>
            )}  
          </div>
        </div>
    )}
    {handleUpdatePopup && (
      <div className='popup'>
        <div className='popup-content'>
          <span className="close" onClick={handleCloseClick}>
              &times;
          </span>
          <div>{updateUserResponse}</div>
          {!updateUserSuccess &&(
            <div>
            <h2 className="popup-title">Bitte Ausfüllen</h2>
            <form onSubmit={handleUserUpdateSubmit} className="popup-form">
              <label htmlFor="first-name" className="popup-label">
                Vorname:
                <input
                  id="first-name"
                  type="text"
                  className="popup-input"
                  value={newUserFirstName}
                  onChange={(e) => setNewUserFirstName(e.target.value)}
                  placeholder="Geben Sie den Vornamen ein"
                />
              </label>
    
              <label htmlFor="last-name" className="popup-label">
                Nachname:
                <input
                  id="last-name"
                  type="text"
                  className="popup-input"
                  value={newUserLastName}
                  onChange={(e) => setNewUserLastName(e.target.value)}
                  placeholder="Geben Sie den Nachnamen ein"
                />
              </label>
              
              <label htmlFor="role-select" className="popup-label">
                Rolle:
                <select
                  id="role-select"
                  className="popup-select"
                  onChange={(e) => handleUserRole(e.target.value)}
                >
                  <option value="">
                    Rolle auswählen
                  </option>
                  <option value="administrator">SuperUser</option>
                  <option value="kanzlei">SteuerberaterKanzlei</option>
                  <option value="firma">Firma</option>
                </select>
              </label>

              <button type="submit" className="popup-submit-button">
                Speichern
                </button>
              </form>
            </div>
          )} 

        </div>
      </div>
    )}
    <div className="pagination-container">
        <button
          className="pagination-button"
          onClick={() =>
            setAllUserDataCurrentPage((prev) => Math.max(prev - 1, 1))
          }
          disabled={allUserDataCurrentPage === 1}
        >
          Previous
        </button>

        {Array.from({ length: allUserDataTotalPages }, (_, i) => (
          <button
            key={i + 1}
            className={`pagination-button ${
              allUserDataCurrentPage === i + 1 ? "active" : ""
            }`}
            onClick={() => setAllUserDataCurrentPage(i + 1)}
          >
            {i + 1}
          </button>
        ))}

        <button
          className="pagination-button"
          onClick={() =>
            setAllUserDataCurrentPage((prev) =>
              Math.min(prev + 1, allUserDataTotalPages)
            )
          }
          disabled={allUserDataCurrentPage === allUserDataTotalPages}
        >
          Next
        </button>
      </div> 
    </div>    
    </div>
  );
};

export default ManageUsers;